var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.848 13.252L9.978 9.382C10.679 8.453 11.1 7.301 11.1 6.05C11.1 2.99 8.611 0.5 5.55 0.5C2.49 0.5 0 2.99 0 6.05C0 9.111 2.49 11.6 5.55 11.6C6.801 11.6 7.953 11.179 8.882 10.478L12.752 14.348C12.903 14.499 13.102 14.576 13.3 14.576C13.498 14.576 13.696 14.5 13.848 14.348C14.151 14.045 14.151 13.555 13.848 13.252ZM1.1 6.05C1.1 3.596 3.097 1.6 5.55 1.6C8.004 1.6 10 3.597 10 6.05C10 8.503 8.004 10.5 5.55 10.5C3.096 10.5 1.1 8.504 1.1 6.05Z",
    fill: "#1D1D1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.42867656.svg";
export { ForwardRef as ReactComponent };